import { AppBar, Box, Container, FormControl, Menu, MenuItem, Select, Toolbar, Button, IconButton } from '@mui/material'
import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Logo from '../../../resources/images/logo-black 1.png';
import { sideNavs } from '../../../constants';
import { useFetchAllProjectSites } from '../../../services/FetchProjects';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { getProjectByName } from '../../../utils/mergeData';

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedSite, setSelectedSite] = useState(null);
    const [projectSite, setProjectList] = useState([]);
    const [projectCarbonSite, setProjectCarbonList] = useState([]);
    const [projectEnvSite, setProjectEnvList] = useState([]);

    const selectedProjectStr = localStorage.getItem('selectedProject');
    const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : null;

    const currentProject = getProjectByName(selectedProject?.project_name);
    const currentProjectSite = currentProject;
    const currentProjectCarbon = currentProject;
    const currentProjectEnv = currentProject;

    const handleOpenMenu = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelectSite = (site: any) => {
        localStorage.setItem('SelectedDropDownSite', JSON.stringify(site))
        navigate('/biodiversity-analysis-detail')
        handleClose();
    };
    const handleSelectCarbonSite = (site: any) => {
        localStorage.setItem('SelectedDropDownCarbonSite', JSON.stringify(site))
        navigate('/carbonanalysis-analysis-detail')
        handleClose();
    };
    const handleSelectEnvSite = (site: any) => {
        localStorage.setItem('SelectedDropDownEnvSite', JSON.stringify(site))
        navigate('/environmentalreport-analysis-detail')
        handleClose();
    };

    return (
        <AppBar position="fixed" color="inherit" className="header">
            <Container maxWidth={false} sx={{ maxWidth: '1736px' }}>
                <Toolbar
                    disableGutters
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <Box display="flex" alignSelf="stretch">
                        <Link to="/" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                            <Box className="logo" display="flex" alignItems="center" height="100%">
                                <img src={Logo} alt="Logo" />
                            </Box>
                        </Link>
                    </Box>

                    {location.pathname === '/' ? null : (
                        <Box
                            className="header-navlinks"
                            sx={{ display: { xs: 'block', sm: 'none', md: 'block' } }}
                        >
                            <Box
                                className="top-navs"
                                sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                            >
                                {sideNavs.map((item) => (
                                    <Box key={item.text}>
                                        <Link
                                            to={item.path === '/project-details' && selectedProject 
                                                ? `${item.path}/${selectedProject.project_name.replace(/\s+/g, '-')}` 
                                                : item.path}
                                            style={{
                                                fontSize: '14px',
                                                fontWeight: 500,
                                                // fontFamily: 'Poppins, sans-serif',
                                                textDecoration: 'none',
                                                margin: '10px',
                                            }}
                                            className={
                                                (location.pathname.startsWith('/biodiversity') &&
                                                    item.path === '/biodiversity') ||
                                                    (location.pathname.startsWith('/carbonanalysis') &&
                                                        item.path === '/carbonanalysis') ||
                                                    (location.pathname.startsWith('/environmentalreport') &&
                                                        item.path === '/environmentalreport')
                                                    ? 'active-link'
                                                    : location.pathname === item.path
                                                        ? 'active-link'
                                                        : ''
                                            }
                                        >
                                            {item.text}
                                        </Link>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}
                </Toolbar>
            </Container>

            {location.pathname.startsWith('/biodiversity') && (
                <Box className="sub-header">
                    <Box sx={{ m: '15px' }}>
                        <Link
                            to="/biodiversity"
                            style={{
                                fontSize: '14px',
                                fontWeight: 500,
                                // fontFamily: 'Poppins, sans-serif',
                                textDecoration: 'none',
                            }}
                            className={
                                location.pathname === '/biodiversity'
                                    ? 'sub-active-link'
                                    : 'un-active-link'
                            }
                        >
                            Dashboard
                        </Link>

                        {/* Analysis with Dropdown Menu */}
                        <Box
                            sx={{ display: 'inline-block', position: 'relative' }}
                            onMouseEnter={handleOpenMenu}
                            onMouseLeave={handleClose}
                        >
                            <Link
                                to="/biodiversity-analysis-detail"
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    // fontFamily: 'Poppins, sans-serif',
                                    cursor: 'pointer',
                                    textDecoration: 'none',
                                }}
                                className={
                                    location.pathname === '/biodiversity-analysis-detail'
                                        ? 'sub-active-link'
                                        : 'un-active-link'
                                }
                            >
                                Analysis
                            </Link>

                            {/* Dropdown Menu */}
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                sx={{
                                    mt: 1,
                                    '& .MuiMenuItem-root': {
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        // fontFamily: 'Poppins, sans-serif',
                                        px: 2,
                                        py: 1,
                                    },
                                }}
                            >
                                {(currentProjectSite as any)?.sites?.map((site: any, index: any) => (
                                        <MenuItem
                                            key={index}
                                            onClick={() => handleSelectSite(site)}
                                        >
                                            {site.site_name}
                                        </MenuItem>
                                    ))}
                            </Menu>
                        </Box>

                        <Link
                            to="/biodiversitycredits"
                            style={{
                                fontSize: '14px',
                                fontWeight: 500,
                                // fontFamily: 'Poppins, sans-serif',
                                textDecoration: 'none',
                            }}
                            className={
                                location.pathname === '/biodiversitycredits'
                                    ? 'sub-active-link'
                                    : 'un-active-link'
                            }
                        >
                            Credits
                        </Link>
                    </Box>
                </Box>
            )}
            {location.pathname.startsWith('/carbonanalysis') ? (
                <Box className='sub-header'>
                    <Box sx={{ m: '15px' }}>
                        <Link
                            to='/carbonanalysis'
                            style={{
                                fontSize: "14px", fontWeight: 500, 
                                // fontFamily: "Poppins, sans-serif", 
                                textDecoration: 'none'
                            }}
                            className={
                                location.pathname === '/carbonanalysis'
                                    ? 'sub-active-link'
                                    : 'un-active-link'
                            }
                        >
                            Dashboard
                        </Link>
                        <Box
                            sx={{ display: 'inline-block', position: 'relative' }}
                            onMouseEnter={handleOpenMenu}
                            onMouseLeave={handleClose}
                        >
                            <Link
                                to='/carbonanalysis-analysis-detail'
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    // fontFamily: 'Poppins, sans-serif',
                                    cursor: 'pointer',
                                    textDecoration: 'none'
                                }}
                                className={location.pathname === '/carbonanalysis-analysis-detail' ? 'sub-active-link' : 'un-active-link'}
                                onClick={handleOpenMenu}
                            >
                                Analysis
                            </Link>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                sx={{
                                    mt: 1,
                                    '& .MuiMenuItem-root': {
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        // fontFamily: 'Poppins, sans-serif',
                                        px: 2,
                                        py: 1,
                                    },
                                }}
                            >
                                {(currentProjectCarbon as any)?.sites?.map((site: any, index: any) => (
                                    <MenuItem
                                        key={index}
                                        onClick={() => handleSelectCarbonSite(site)} // Set the selected site
                                    >
                                        {site.site_name}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                        <Link
                            to='/carbonanalysiscredits'
                            style={{
                                fontSize: "14px", fontWeight: 500,
                                //  fontFamily: "Poppins, sans-serif",
                                textDecoration: 'none'
                            }}
                            className={location.pathname === '/carbonanalysiscredits' ? 'sub-active-link' : 'un-active-link'}
                        >
                            Credits
                        </Link>
                    </Box>
                </Box>
            ) : null}
            {location.pathname.startsWith('/environmentalreport') ? (
                <Box className='sub-header'>
                    <Box sx={{ m: '15px' }}>
                        <Link
                            to='/environmentalreport'
                            style={{
                                fontSize: "14px", fontWeight: 500, 
                                // fontFamily: "Poppins, sans-serif", 
                                textDecoration: 'none'
                            }}
                            className={
                                location.pathname === '/environmentalreport'
                                    ? 'sub-active-link'
                                    : 'un-active-link'
                            }
                        >
                            Dashboard
                        </Link>
                        <Box
                            sx={{ display: 'inline-block', position: 'relative' }}
                            onMouseEnter={handleOpenMenu}
                            onMouseLeave={handleClose}
                        >
                            <Link
                                to="/environmentalreport-analysis-detail"
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    // fontFamily: 'Poppins, sans-serif',
                                    cursor: 'pointer',
                                    textDecoration: 'none',
                                }}
                                className={
                                    location.pathname === '/environmentalreport-analysis-detail'
                                        ? 'sub-active-link'
                                        : 'un-active-link'
                                }
                            >
                                Analysis
                            </Link>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                sx={{
                                    mt: 1,
                                    '& .MuiMenuItem-root': {
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        // fontFamily: 'Poppins, sans-serif',
                                        px: 2,
                                        py: 1,
                                    },
                                }}
                            >
                                {(currentProjectEnv as any)?.sites?.map((site: any, index: any) => (
                                        <MenuItem
                                            key={index}
                                            onClick={() => handleSelectEnvSite(site)}
                                        >
                                            {site.site_name}
                                        </MenuItem>
                                    ))}
                            </Menu>
                        </Box>
                    </Box>
                </Box>
            ) : null}
        </AppBar>
    )
}

export default Header